import React from 'react';
import { useHistory } from 'react-router-dom';
import RoutesConst from '../../blocks/consts/RoutesConst';
import I18n from '../../blocks/localization';
import icon_e_novcanik from '../../assets/icons/1x/icon_e-novcanik.png';
import icon_faq from '../../assets/icons/1x/icon-faq.png';
import icon_selling_spots from '../../assets/icons/1x/icon_prodajna-mjesta.png';
import icon_penalty_pay from '../../assets/icons/1x/penalty_pay_24px.png';
import icon_bus_lines from '../../assets/icons/1x/icon_vozni-red.png';
import icon_my_coupons from '../../assets/icons/1x/icon_moji-kuponi.png';
import icon_transaction from '../../assets/icons/1x/icon-transaction.png';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import SessionStorageConst from '../../blocks/consts/SessionStorageConst';
import { Language } from '../../blocks/localization/Language';
import { BUS_LINES_URL } from '../../config';

const LeftNavigation = () => {
    const isAuthenticated = useSelector((state: ApplicationState) => state.auth.isAuthenticated);
    const clientId = useSelector((state: ApplicationState) => state.account.account?.clientId);

    const history = useHistory();

    const language = sessionStorage.getItem(SessionStorageConst.Language) as Language;
    const busLinesUrl = BUS_LINES_URL[language];

    const redirect = (route: string) => {
        history.push(route);
    }

    return (
        <div className="left-navigation">
            <ul className="items-list">
                <li onClick={() => redirect(RoutesConst.EWallet)}>
                    <img src={icon_e_novcanik} alt="eNovčanik" />
                    <span>{I18n.t('leftNavigation.eWallet')}</span>
                </li>
                <li onClick={() => redirect(RoutesConst.PenaltyPay)} className="border-top">
                    <img src={icon_penalty_pay} alt="penaltyPayment" />
                    {I18n.t('login.info.penalty')}
                </li>
                {
                    isAuthenticated && clientId &&
                    <li onClick={() => redirect(RoutesConst.MyCoupons)}>
                        <img src={icon_my_coupons} alt="kuponi" />
                        <span>{I18n.t('leftNavigation.myCoupons')}</span>
                    </li>
                }
                {
                    isAuthenticated &&
                    <li onClick={() => redirect(RoutesConst.MyTransactions)}>
                        <img src={icon_transaction} alt="transkacije" />
                        <span>{I18n.t('leftNavigation.myTransactions')}</span>
                    </li>
                }
                <li>
                    <a href={busLinesUrl} target="_blank">
                        <img src={icon_bus_lines} alt="Vozni red" />
                        <span>{I18n.t('login.info.busLines')}</span>
                    </a>
                </li>
                {/* <li onClick={() => redirect(RoutesConst.RouteCalculation)}>
                    <img src={icon_mapa} alt="Izračun rute" />
                    <span>{I18n.t('leftNavigation.routeCalculation')}</span>
                </li> */}
                <li onClick={() => redirect(RoutesConst.SellingSpots)}>
                    <img src={icon_selling_spots} alt="Prodajna mjesta" />
                    <span>{I18n.t('leftNavigation.sellingSpots')}</span>
                </li>
                <li onClick={() => redirect(RoutesConst.FrequentylAskedQuestions)}>
                    <img src={icon_faq} alt="Česta pitanja" />
                    <span>{I18n.t('leftNavigation.frequentlyAskedQuestions')}</span>
                </li>
            </ul>
        </div>
    );
}

export default LeftNavigation;
